























import Vue from 'vue'

export default Vue.extend({
    data() {
        return {
        }
    },
    methods: {
        remove() {
            (this as any).params.remove((this as any).params.data);
        },
        edit() {
            (this as any).params.edit((this as any).params.data);
        },
        update() {
            (this as any).params.update((this as any).params.data);
        },
        toggle() {
            (this as any).params.toggle((this as any).params.data);
        }
    },
    computed: {
    }
})
